module.exports = __webpack_public_path__ + "static/media/get-started-es.4a354fbe.png";